import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class AccountService {
    private http = inject(HttpClient);
    private BASE_URL = environment.api.url;

    readonly isVerified = signal<boolean | null>(null);

    loadProviderStatus(email: string): void {
        this.http.get<boolean>(`${this.BASE_URL}/account/status`, {
            params: { email }
        }).subscribe({
            next: (verified) => {
                this.isVerified.set(verified)
            },
            error: () => {
                this.isVerified.set(false)
            }
        });
    }
}